import { useState } from "react";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Existing year data for Recovered and Pending charts
const yearData = {
  2020: {
    recovered: [4000, 5000, 9000, 8000, 6000, 7000, 5000, 8000, 9000, 8550, 7000, 4000],
    pending: [2500, 3500, 6000, 4000, 3000, 2000, 1500, 2500, 3500, 3000, 2000, 1000],
  },
  2021: {
    recovered: [6000, 7000, 8000, 9000, 6500, 6200, 7000, 8500, 9000, 9500, 8000, 6000],
    pending: [3000, 4000, 2500, 3500, 4000, 3000, 2500, 3000, 4000, 4500, 3500, 2000],
  },
  2022: {
    recovered: [8000, 9000, 5000, 9000, 5150, 6100, 5000, 8000, 9000, 8550, 7000, 4000],
    pending: [4000, 5000, 2500, 6000, 2500, 4000, 3500, 6000, 6000, 6500, 6000, 2500],
  },
  2023: {
    recovered: [9000, 9500, 8000, 10000, 8500, 9000, 9500, 10000, 11000, 10500, 9000, 8000],
    pending: [5000, 6000, 4000, 5000, 3000, 2000, 2500, 3000, 4000, 5000, 4500, 3000],
  },
  2024: {
    recovered: [10000, 11000, 9500, 12000, 10500, 11500, 9000, 10000, 11000, 11500, 9000, 10000],
    pending: [6000, 7000, 5000, 6000, 4000, 3000, 3500, 4000, 5000, 6000, 5500, 4000],
  },
  2025: {
    recovered: [10000, 11000, 9500, 12000, 10500, 11500, 9000, 10000, 11000, 11500, 9000, 10000],
    pending: [6000, 7000, 5000, 6000, 4000, 3000, 3500, 4000, 5000, 6000, 5500, 4000],
  },
};

export const BarChart = ({ chartType = "recovery", chartData, options }) => {
  const [selectedYear, setSelectedYear] = useState(2025);

  const handleChange = (event) => {
    setSelectedYear(event.target.value);
  };

  // Render chart with passed data for "grades" or "inquiries"
  if (chartType === "grades" || chartType === "inquiries") {
    return (
      <div>
        <Bar data={chartData} options={options} />
      </div>
    );
  }

  // Default recovery chart rendering
  const currentData = yearData[selectedYear];
  const recoveryData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    datasets: [
      {
        label: "Recovered",
        data: currentData.recovered,
        backgroundColor: "rgba(0, 123, 255, 0.9)",
        borderRadius: 3,
        barThickness: 10,
      },
      {
        label: "Pending",
        data: currentData.pending,
        backgroundColor: "rgba(0, 123, 255, 0.4)",
        borderRadius: 3,
        barThickness: 10,
      },
    ],
  };

  const recoveryOptions = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
        labels: {
          boxHeight: 8,
        },
      },
    },
    scales: {
      x: {
        stacked: true,
        title: {
          display: true,
          text: "Months",
        },
      },
      y: {
        stacked: true,
        title: {
          display: true,
          text: "Amount",
        },
      },
    },
  };

  return (
    <div>
      <select
        value={selectedYear}
        onChange={handleChange}
        className="form-select ms-auto"
        style={{ width: "100px", position: "relative", top: "-25px" }}
      >
        {Object.keys(yearData).map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
      <Bar data={recoveryData} options={recoveryOptions} />
    </div>
  );
};